import { useTranslation } from 'react-i18next'
import { Icon } from '@iconify/react'
import Chip from '@mui/material/Chip'
import type { SaveState } from './usePlanDraft'

// Whether the plan on screen is the one on the server. "Not saved" is
// normal at an airfield with no signal: the draft is kept and sent again.
export default function SaveStateChip({ state }: { state: SaveState }) {
  const { t } = useTranslation()
  if (state === 'saved') {
    return <Chip size="small" variant="outlined" icon={<Icon icon="mdi:cloud-check-outline" />} label={t('plan.editor.saved')} />
  }
  if (state === 'saving') {
    return <Chip size="small" variant="outlined" icon={<Icon icon="mdi:cloud-upload-outline" />} label={t('plan.editor.saving')} />
  }
  return <Chip size="small" color="warning" icon={<Icon icon="mdi:cloud-off-outline" />} label={t('plan.editor.unsaved')} />
}
